import { useModalActions } from "@store/modal/modal";
import { useSavingsPlanBankAccountsQuery } from "@services/budget/queries";
import { AddSavingsPlanModal } from "./AddSavingsPlanModal";

export const useAddSavingsPlanModal = () => {
  const { create } = useModalActions();
  const { data: savingsPlanBankAccounts } = useSavingsPlanBankAccountsQuery();

  const openAddSavingsPlanModal = () => {
    if (!savingsPlanBankAccounts) {
      return;
    }

    create((modalProps) => (
      <AddSavingsPlanModal
        savingsPlanBankAccounts={savingsPlanBankAccounts}
        {...modalProps}
      />
    ));
  };

  return { openAddSavingsPlanModal };
};
